import { Typography } from "antd";
import { styled } from "styled-components";


const ContentExpiredStyled = styled.div`
  display: flex;
  padding: 24px;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;

  p{
    color: ${({ theme }) => theme?.colors?.text?.paragraphs};
    text-align: center;
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
    line-height: 150%; /* 24px */
  }
`;

const TitleStyled = styled(Typography)`
  color: ${({ theme }) => theme?.colors?.text?.headings};
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%; /* 24px */

  span {
    color: ${({ theme }) => theme?.colors?.theme?.brandColor3};
  }

  &.success {
    color: ${({ theme }) => theme?.colors?.theme?.success};
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 28.8px */
  }

  &.expired-mission {
    color: ${({ theme }) => theme?.colors?.text?.paragraphs};
    text-align: center;
    font-size: 24px;
    font-style: normal;
    font-weight: 700;
    line-height: 150%; /* 24px */
  }
`;

export {
	ContentExpiredStyled,
	TitleStyled
}